import type { ChartData, VehicleCategoryOption } from '../model';

/**
 * Fixed palette keyed by vehicle category id, matching the legacy transport
 * report. Color management moved here from the backend (`342405`) — the API
 * no longer sends series colors for the transport chart.
 */
export const VEHICLE_CATEGORY_COLORS: Record<number, string> = {
  1: '#c0392b',
  2: '#34495e',
  3: '#801638',
  4: '#c0392b',
  5: '#2b3c4e',
  6: '#709ecc',
  7: '#c0392b'
};

export const getVehicleCategoryColor = (id?: number): string | undefined =>
  id !== undefined ? VEHICLE_CATEGORY_COLORS[id] : undefined;

/**
 * Assigns vehicle-category colors to transport chart series. Each series
 * carries its category description in `stack`; ids come from the dashboard
 * options reference. Unmapped categories get no color, so the chart-level
 * guard (resolveSeriesColors) falls back to the ECharts palette whenever
 * the palette leaves gaps or duplicates (e.g. breakdown mode, ids 1/4/7).
 */
export const applyVehicleCategoryColors = (data: ChartData, vehicleCategories?: VehicleCategoryOption[]): ChartData => {
  if (!vehicleCategories?.length) {
    return data;
  }

  const idByDescription = new Map(vehicleCategories.map((category) => [category.description, category.id]));

  return {
    ...data,
    series: data.series.map((series) => ({
      ...series,
      color: series.stack ? getVehicleCategoryColor(idByDescription.get(series.stack)) : undefined
    }))
  };
};
